import * as Common from '@/tenant/common';

export class BarcodeItem extends Common.ObjectBase{
  constructor(){
    super('BarcodeItem');
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.sku = new Common.ModelBinder(Common.SKU);    
    this.binders.uom = new Common.ModelBinder(Common.Conversion);       
  }
  public shelfNo:string = '';
  public itemNo: string = ''; //検品アイテムキー(結果照合用)
  public commodity : Common.Commodity;
  public sku : Common.SKU;
  public uom : Common.Conversion;
  public barcode: string = ''; //バーコード
  public targetQuantity: number = 0; //検品数量
  public scannedQuantity: number = 0; //検品結果
  public allowUnmatch: boolean = false; //不一致許可
    public maxQuantity: number = null; //最大出荷可能数量 or 最大移動可能数量

  public get isCompleted():boolean{
    return this.targetQuantity == this.scannedQuantity || this.allowUnmatch;
  }

  public get uomDescription(){
    return String.format('{0} (入数: {1})',this.uom.name ,this.uom.rate);
  }  
}

export class BarcodeVoucher extends Common.ObjectBase{
  constructor(){
    super('BarcodeVoucher');
    this.binders.warehouse = new Common.ModelBinder(Common.Counterpart);
    this.binders.segment = new Common.ModelBinder(Common.Segment);    
    this.binders.counterpart = new Common.ModelBinder(Common.Counterpart);       
  }
  public voucherNo: string; //検品アイテムキー(結果照合用)
  public refNo: string; //管理番号
  public warehouse : Common.Counterpart;
  public segment : Common.Segment;
  public counterpart : Common.Counterpart;
  public date: Date; //バーコード
  public pic: string; //検品数量
  public description: string; //検品結果
  public get name(){
    return this.counterpartName ? this.counterpartName :(this.counterpart? this.counterpart.name : '');
  }
  public counterpartName:string;
  public isCompleted:boolean = false;

}

export enum InspectionModes{
  none = 0,  
  picking = 1,
  shipping = 2,
  receipt = 4,
  stock = 8,
  salesOrder = 16,
  purchaseOrder = 32,
  shippingRegistration = 64,
  receiptRegistration = 128,
  stockTransferRegistration = 256,
  stockTransfer = stockTransferRegistration,
  pickingAndShipping = picking | shipping,
}

export class BarcodeVoucherQuery extends Common.LoadQuery {
  constructor(mode:Common.InspectionModes, pickingNo:string,token:string,showCompletedVoucher:boolean,showDeliveryDateToDay:boolean){
    super('BarcodeVoucherQuery',BarcodeVoucher);
    this.sort = 'itemNo';
    this.loadAll = true;
    this.mode = mode;
    this.pickingNo = pickingNo;
    this.token = token;
    this.showCompletedVoucher = showCompletedVoucher;
    this.showDeliveryDateToDay = showDeliveryDateToDay;
  }
  public mode: Common.InspectionModes;
  public pickingNo: string;  
  public token: string;
  public showCompletedVoucher: boolean;
  public showDeliveryDateToDay: boolean;
}

export class BarcodeItemQuery extends Common.LoadQuery {
  constructor(mode:Common.InspectionModes, voucherNo:string, warehouseId:Number, token:string, barcode:string = '', registrationHeader:any = null){
    super('BarcodeItemQuery',BarcodeItem);
    this.sort = 'itemNo';
    this.loadAll = true;
    this.mode = mode;
    this.voucherNo = voucherNo;
    this.warehouseId = warehouseId;
    this.token = token;
    this.barcode = barcode;
    this.registrationHeader = registrationHeader;
    this.segmentId = registrationHeader && registrationHeader.segment ? registrationHeader.segment.id : null;
    this.shippingWarehouseId = registrationHeader && registrationHeader.shippingWarehouse ? registrationHeader.shippingWarehouse.id : null;
    this.targetDate = registrationHeader ? registrationHeader.date : null;
  }
  public mode: Common.InspectionModes;
  public voucherNo: string;
  public warehouseId: Number;  
  public token:string;
  public barcode:string;
  public registrationHeader:any;
  public segmentId:number;
  public shippingWarehouseId:number;
  public targetDate:Date;
}

export class BarcodeItemUpdateQuery extends Common.Query {
  constructor(mode:Common.InspectionModes, voucherNo:string, items: Array<BarcodeItem>, token:string, warehouseId:number, registrationHeader:any = null, confirmVoucherStateOnInspectionCompleted:boolean = false){
    super('BarcodeItemUpdateQuery',null);
    this.mode = mode;
    this.voucherNo = voucherNo;
    this.items = items;
    this.token = token;
    this.warehouseId = warehouseId;
    this.registrationHeader = registrationHeader;
    this.confirmVoucherStateOnInspectionCompleted = confirmVoucherStateOnInspectionCompleted;
  }
  public mode: Common.InspectionModes;
  public voucherNo: string;
  public items: Array<BarcodeItem>;
  public token:string;
  public warehouseId: number;
  public registrationHeader:any;
  public confirmVoucherStateOnInspectionCompleted:boolean;
}

export class BarcodeLicenseValidateQuery extends Common.Query{
  constructor(token:string){
    super('BarcodeLicenseValidateQuery',null);
    this.token = token;
  }  
  public token:string;
}